import Vue from 'vue';
import Vuex, { StoreOptions, GetterTree, MutationTree } from 'vuex';
import { RootState } from './RootState';
import { MessageStore } from './MessageStore';
import { CriteriaStore } from './CriteriaStore';
import { SecurityStore } from './security/SecurityStore';
import { InvoicingStore } from './InvoicingStore';

Vue.use(Vuex);

/**
 * Constantes pour les méthodes du store.
 */
export enum IndexStoreMethods {
    GET_MOIS_EN_COURS = 'GET_MOIS_EN_COURS',
    SET_MOIS_EN_COURS = 'SET_MOIS_EN_COURS',
}

/**
 * Getters du store.
 */
const getters: GetterTree<RootState, RootState> = {
    [IndexStoreMethods.GET_MOIS_EN_COURS]: (state) => state.moisEnCours,
};

/**
 * Mutateurs du store.
 */
const mutations: MutationTree<RootState> = {
    [IndexStoreMethods.SET_MOIS_EN_COURS]: (state: RootState, moisEnCours: string) => state.moisEnCours = moisEnCours,
};

const store: StoreOptions<RootState> = {
    state: new RootState(),
    modules: {
        MessageStore,
        SecurityStore,
        CriteriaStore,
        InvoicingStore 
    },
    getters,
    mutations
};

export default new Vuex.Store<RootState>(store);
